import { useQuery, useInfiniteQuery } from '@tanstack/react-query';
import { getSdk } from '@/lib/sdk';
import type { BlogListOptions } from '@cc-consulting-nv/ccsdk';

export const blogKeys = {
  all: ['blog'] as const,
  list: (opts?: BlogListOptions) => ['blog', 'list', opts] as const,
  featured: () => ['blog', 'featured'] as const,
  categories: () => ['blog', 'categories'] as const,
  detail: (slug: string) => ['blog', 'post', slug] as const,
};

export function useBlogPosts(opts?: Omit<BlogListOptions, 'cursor'>) {
  const sdk = getSdk();
  return useInfiniteQuery({
    queryKey: blogKeys.list(opts),
    queryFn: async ({ pageParam }) => {
      return sdk.listBlogPosts({ ...opts, cursor: pageParam ?? undefined });
    },
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    initialPageParam: undefined as string | undefined,
  });
}

export function useFeaturedBlogPosts() {
  const sdk = getSdk();
  return useQuery({
    queryKey: blogKeys.featured(),
    queryFn: () => sdk.getFeaturedBlogPosts(),
  });
}

export function useBlogCategories() {
  const sdk = getSdk();
  return useQuery({
    queryKey: blogKeys.categories(),
    queryFn: () => sdk.getBlogCategories(),
  });
}

export function useBlogPost(slug: string | undefined) {
  const sdk = getSdk();
  return useQuery({
    queryKey: blogKeys.detail(slug ?? ''),
    queryFn: () => sdk.getBlogPost(slug!),
    enabled: Boolean(slug),
  });
}
